@if(showContent) {
   
<div class="page-panel">
     <div class="page-panel-header" [ngClass]="'backcolor-plangebiet-' + appStateService.navigationPlangebiet() + '-light'">
        @if (showBackButton) {
            <button mat-icon-button color="primary" class="button-small-icon-contrast page-panel-header-back-button" (click)="button_back_clicked()">
                <span color="secondary" class="material-symbols-outlined icon-24px-contrast icon-padding-left-6px">arrow_back_ios</span>
            </button>
        }
        @if (iconNameIonicon) {
            <span color="primary" class="page-panel-header-ionicon menu-icon icon ion-md-{{iconNameIonicon}} icon-28px-contrast"></span>
        }
        @if (iconNameFontAwesome) {
            <span color="primary" class="page-panel-header-icon menu-icon material-symbols-outlined icon-28px-contrast">{{iconNameFontAwesome}}</span>
        }
        <span class="page-panel-header-title font-subtitle-contrast">{{pageTitle}}</span>
        <span class="flex-fill"></span>       
        @if (customButton1Title || customButton2Title) {
            <div class="flex flex-row flex-gap-8">
                @if (customButton1Title) {
                    <button mat-stroked-button class="button-large-contrast" (click)="button_custom1_clicked()">{{customButton1Title}}</button>
                }
                @if (customButton2Title) {
                    <button mat-stroked-button class="button-large-contrast" (click)="button_custom2_clicked()">{{customButton2Title}}</button>
                }
            </div>
        }
        @if (showCheckedButton || showInfoButton || showEditButton || showDeleteButton || showHistoryButton || showDetailsButton || showSidepanelButton || showCloseButton) {
            <div class="flex flex-row flex-gap-8">
                @if (showCheckedButton) {
                    <button mat-icon-button color="primary" class="button-small-icon-contrast " (click)="button_checked_clicked()">
                        <span color="secondary" class="material-symbols-outlined icon-24px-contrast">done_all</span>
                    </button>
                }
                @if (showInfoButton) {
                    <button mat-icon-button color="primary" class="button-small-icon-contrast " (click)="button_info_clicked()">
                        <span color="secondary" class="material-symbols-outlined icon-24px-contrast">error</span>
                    </button>
                }
                @if (showEditButton) {
                    <button mat-icon-button color="primary" class="button-small-icon-contrast " (click)="button_edit_clicked()">
                        <span color="secondary" class="material-symbols-outlined icon-24px-contrast">edit_square</span>
                    </button>
                }
                @if (showDeleteButton) {
                    <button mat-icon-button color="primary" class="button-small-icon-contrast " (click)="button_delete_clicked()">
                        <span color="secondary" class="material-symbols-outlined icon-24px-contrast">delete</span>
                    </button>
                }
                @if (showHistoryButton) {
                    <button mat-icon-button color="primary" class="button-small-icon-contrast " (click)="button_history_clicked()">
                        <span color="secondary" class="material-symbols-outlined icon-24px-contrast">device_reset</span>
                    </button>
                }
                @if (showDetailsButton) {
                    <button mat-icon-button color="primary" class="button-small-icon-contrast " (click)="button_details_clicked()">
                        <span color="secondary" class="material-symbols-outlined icon-24px-contrast">more_horiz</span>
                    </button>
                }
                @if (showSidepanelButton) {
                    <button mat-icon-button color="primary" class="button-small-icon-contrast " (click)="button_sidepanel_clicked()">
                        <span color="secondary" class="material-symbols-outlined icon-24px-contrast">dock_to_left</span>
                    </button>
                }
                @if (showCloseButton) {
                    <button mat-icon-button color="primary" class="button-small-icon-contrast " (click)="button_close_clicked()">
                        <span color="secondary" class="material-symbols-outlined icon-24px-contrast">close</span>
                    </button>
                }
            </div>
        }
    </div>
    <div class="flex-fill flex-stretch-self element-panel-content page-panel-content page-border-light">
        <ng-content></ng-content>
    </div>        
</div>
}